import { useRouter } from "next/router";
import { useCallback } from "react";
import { FIELDS, SEARCH_TYPE, mapSearchType } from "~/utils/constants";
import Loading from "../Loading";

const FormAdvanceSearch = ({
  searchText,
  setSearchText,
  fields,
  setFields,
  searchType,
  setSearchType,
  loading,
}) => {
  const router = useRouter();
  const searchTextChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setSearchText(event.target.value);
    },
    []
  );

  function handleChange(event) {
    setSearchType(event.target.value);
  }

  const onFieldsChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        setFields((f) => f.concat([event.target.value as FIELDS]));
      } else {
        setFields((array) => array.filter((f) => f !== event.target.value));
      }
    },
    []
  );

  const onSubmit = (event) => {
    event.preventDefault();
    const routerQuery = router.query;
    if (!searchText) return;

    delete routerQuery.sources;
    delete routerQuery.subsources;
    delete routerQuery.page;
    delete routerQuery.order;

    routerQuery.q = searchText;
    routerQuery.fields = fields;
    routerQuery.searchType = searchType;

    router.push({ ...router, query: routerQuery, hash: "risultati" }, null, {
      scroll: false,
    });
  };

  const onReset = (event) => {
    event.preventDefault();
    router.push("/ricercaAvanzata");
    setFields([FIELDS.CONTENT]);
    setSearchType(SEARCH_TYPE.OR);
    setSearchText("");
  };

  return (
    <form
      onSubmit={onSubmit}
      className="flex flex-col items-center gap-y-12 rounded-[55px] bg-[#eaebec] px-4 py-12 sm:px-12 md:py-16 lg:py-24 xl:rounded-[90px]"
    >
      <div className="flex w-full justify-center">
        <div className="flex w-full flex-col justify-start gap-4 md:flex-row md:items-center">
          <div className="flex">
            <label className="flex text-sm font-bold sm:contents sm:text-base">
              Cerca:
            </label>
          </div>
          <div className="flex w-full flex-col gap-4 md:flex-row">
            <div className="flex w-full">
              <select
                className="w-full border-[1px] border-solid border-black p-4 text-sm sm:text-base "
                value={searchType}
                onChange={handleChange}
              >
                {Object.entries(mapSearchType).map(([idSearchType, text]) => (
                  <option key={idSearchType} value={idSearchType}>
                    {text}
                  </option>
                ))}
              </select>
            </div>
            <div className="input-container flex w-full">
              <input
                type="search"
                className="w-full border-[1px] border-solid border-black py-4 pl-10 text-sm sm:text-base"
                name="cercaPerRilevanza"
                value={searchText}
                onChange={searchTextChange}
                placeholder="Inserisci la parola o frase..."
                required
              />
              <span className="absolute left-3 top-1/2 h-[20px] w-[20px] -translate-y-1/2 content-[url(/icon/ico-search.svg)]"></span>
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full flex-col justify-start gap-x-4 gap-y-8 md:flex-row md:items-center lg:gap-10">
        <div className="flex flex-col gap-4 sm:flex-row">
          <span className="flex w-8 text-sm font-bold sm:text-base">in:</span>
          <div className="flex flex-row flex-wrap gap-4">
            <span className="">
              <label className="form-control flex items-center text-sm sm:text-base">
                <input
                  type="checkbox"
                  className="mr-4"
                  value={FIELDS.CONTENT}
                  onChange={onFieldsChange}
                  checked={fields.includes(FIELDS.CONTENT)}
                />
                Contenuto
              </label>
            </span>
            <span className="">
              <label className="form-control flex items-center text-sm sm:text-base">
                <input
                  type="checkbox"
                  className="mr-4"
                  value={FIELDS.AUTORE}
                  onChange={onFieldsChange}
                  checked={fields.includes(FIELDS.AUTORE)}
                />
                Autore
              </label>
            </span>
          </div>
        </div>
        <span className="hidden h-7 border-r-2 border-solid border-gray md:flex"></span>
        <div className="flex flex-col gap-4 sm:flex-row">
          <span className="flex w-auto text-sm font-bold sm:text-base">
            l&apos;articolo deve contenere:
          </span>
          <div className="flex flex-row gap-4">
            <span className="">
              <label className="form-control flex items-center text-sm sm:text-base">
                <input
                  type="checkbox"
                  className="mr-4"
                  value={FIELDS.AUDIO}
                  onChange={onFieldsChange}
                  checked={fields.includes(FIELDS.AUDIO)}
                />
                Audio
              </label>
            </span>
            <span className="">
              <label className="form-control flex items-center text-sm sm:text-base">
                <input
                  type="checkbox"
                  className="mr-4"
                  value={FIELDS.VIDEO}
                  onChange={onFieldsChange}
                  checked={fields.includes(FIELDS.VIDEO)}
                />
                Video
              </label>
            </span>
          </div>
        </div>
      </div>
      <div
        id="risultati"
        className="flex w-full justify-center text-sm lg:w-4/5 lg:text-base"
      >
        <div className="flex w-full flex-col justify-center gap-4 sm:flex-row">
          <button
            className="w-full border-[1px] border-solid border-orange bg-orange py-4 uppercase text-white lg:w-1/3"
            type="submit"
          >
            <div className="flex items-center justify-center">
              {loading && <Loading />} Cerca
            </div>
          </button>
          <button
            className="btn border-secondary w-full border border-gray bg-gray p-4 text-center uppercase text-white lg:w-1/3"
            type="reset"
            onClick={onReset}
          >
            Reset
          </button>
        </div>
      </div>
    </form>
  );
};

export default FormAdvanceSearch;
